import { useState } from "react";
import { Modal } from "react-bootstrap";
import AlertBox from "../AlertBox";
import { downloadCustomerPartnerInfra } from "../../api/projects";
import { useGroupListHooks } from "../../utils/ProjectsUtilHooks";
import OltPartnerDropdown from "../infrastrucure/OltPartnerDropdown";

export default function ModalDownloadCustomerPartner({ show, onClose, onSuccess }) {
  const { projects } = useGroupListHooks();

  const [formFilter, setFormFilter] = useState({
    is_active: "",
    installation_start_date: "",
    installation_end_date: "",
    project_id: "",
    olt: "",
  });
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    resetFilter();
    onClose();
  };

  const resetFilter = () => {
    setFormFilter({
      is_active: "",
      installation_start_date: "",
      installation_end_date: "",
      project_id: "",
      olt: "",
    });
  };

  const downloadFile = async () => {
    setLoading(true);

    try {
      let response = await downloadCustomerPartnerInfra({ ...formFilter });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Data Pelanggan.xlsx");
      onSuccess("Berhasil mengunduh Data Pelanggan.xlsx");
      document.body.appendChild(link);
      link.click();
      handleClose();
    } catch (error) {
      let message = "Something wrong ... ";

      if (error.response) {
        let { data } = error.response;
        let responseObj = await data.text();
        let responseData = JSON.parse(responseObj);
        message = responseData?.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message: message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Download Data Pelanggan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} setAlert={setAlert} />
        <form>
          <div className="form-group">
            <label>Tanggal Instalasi Mulai</label>
            <input
              type="date"
              className="form-control"
              value={formFilter.installation_start_date}
              onChange={(event) =>
                setFormFilter({ ...formFilter, installation_start_date: event.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Tanggal Instalasi Akhir</label>
            <input
              type="date"
              className="form-control"
              value={formFilter.installation_end_date}
              onChange={(event) =>
                setFormFilter({ ...formFilter, installation_end_date: event.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label htmlFor="projectFilter">Grup/Project</label>
            <select
              className="form-control"
              id="projectFilter"
              value={formFilter.project_id}
              onChange={(event) => setFormFilter({ ...formFilter, project_id: event.target.value })}
            >
              <option value="">SEMUA</option>
              {projects.map((project, index) => (
                <option value={project.id} key={index}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="statusFilter">Status</label>
            <select
              className="form-control"
              id="statusFilter"
              value={formFilter.is_active}
              onChange={(event) => setFormFilter({ ...formFilter, is_active: event.target.value })}
            >
              <option value="">SEMUA</option>
              <option value="0">Isolir</option>
              <option value="1">Aktif</option>
              <option value="2">Dismantled</option>
              <option value="3">Aktif Trial</option>
              <option value="4">Dismantle Trial</option>
              <option value="5">Deaktivasi Isolir</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="oltFilter">OLT</label>
            <OltPartnerDropdown
              value={formFilter.olt}
              onChange={(event) => setFormFilter({ ...formFilter, olt: event.target.value })}
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => handleClose()}>
          Close
        </button>
        <button className="btn btn-primary" onClick={() => downloadFile()} disabled={loading}>
          <i className="fas fa-download"></i> {!loading ? "Unduh Data" : "Harap Tunggu ..."}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
